import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, LogOut, Mail, RefreshCw } from 'lucide-react';

export const PendingApprovalPage = () => {
  const { user, logout, refreshUser } = useAuth();
  const isSuspended = user?.access_reason === 'SUSPENDED';

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-6" data-testid="pending-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-4">
            {isSuspended ? <Mail className="w-8 h-8 text-red-600" /> : <Clock className="w-8 h-8 text-orange-600" />}
          </div>
          <h1 className="font-outfit text-2xl font-bold text-slate-900 mb-2">
            {isSuspended ? 'Accès suspendu' : 'Compte en attente de validation'}
          </h1>
          <p className="text-slate-600 mb-6 text-sm">
            {isSuspended
              ? 'Votre accès a été suspendu par l\'administrateur. Vos données sont conservées. Contactez-nous pour plus d\'informations.'
              : 'Votre inscription a bien été enregistrée. Un administrateur doit valider votre compte avant que vous puissiez accéder à Ledgerly. Vous recevrez un email dès la validation.'}
          </p>
          <p className="text-xs text-slate-500 mb-6">
            Connecté en tant que <b>{user?.email}</b>
          </p>
          <div className="flex gap-2">
            <Button variant="outline" onClick={refreshUser} className="flex-1" data-testid="pending-refresh-btn">
              <RefreshCw className="w-4 h-4 mr-2" /> Actualiser
            </Button>
            <Button variant="outline" onClick={logout} className="flex-1" data-testid="pending-logout-btn">
              <LogOut className="w-4 h-4 mr-2" /> Déconnexion
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingApprovalPage;
